import { QuestionMark } from '@nexus/lib-react/dist/core/Icon/icons/default';
import { mq } from '../../styles';
import styled from '../../../theme/styled';

const InfoButtonContainer = styled.div`
  display: flex;
  border-top: 1px solid ${({ theme }) => theme.colors.grey3};
  padding-top: ${({ theme }) => theme.space[16]};

  ${mq.desktop} {
    order: -1;
    border-top: none;
    padding-top: 0;
    margin-top: 0;
  }
`;

const QuestionMarkIcon = styled(QuestionMark)`
  height: ${({ theme }) => theme.sizes[16]};
  width: ${({ theme }) => theme.sizes[16]};
  margin: 0 ${({ theme }) => theme.sizes[8]} 5px 0;
`;

export default {
  InfoButtonContainer,
  QuestionMarkIcon,
};
